





export default {
  name: "app",
  components: {},
};
